import React from "react";
import { Row } from "react-bootstrap";
import { RadioGroup } from "../../../genericComponents";
import { pensionFormNames } from "../models/pensionFormNames";
import { required } from "../models/required";
import { defaultThreeOptions } from "../models/selects";

function PensionRegister3() {
  return (
    <Row>
      <RadioGroup
        label="O óbito ocorreu no exercício da função (labor)?"
        name={pensionFormNames.occurInTheExerciseOfFunction}
        options={defaultThreeOptions.map((item) => ({
          label: item,
          value: item,
        }))}
        required={required.default}
        inline
      />
    </Row>
  );
}

export default React.memo(PensionRegister3);
